/* CheapBats 2026-09-01 — Lizard Skins grip add-on on bat PDPs (snippets/cb-grip-addon.liquid).
   Selection lives in memory; on the bat form's submit the grip is added to the cart FIRST
   (properties: For bat), then the bat submit proceeds through the theme's own product-form
   handler so the drawer opens showing both lines. */
(function () {
  if (window.__cbGripInit) return;
  window.__cbGripInit = true;

  const STYLE_ORDER = ['Solid', 'Camo', 'Outburst', 'Patriotic', 'MLB Teams', 'Signature', 'Legends'];
  const THK_ORDER = ['0.5mm', '1.1mm', '1.8mm'];
  const LAYOUT = 'stacked';   // 'stacked' = every style group listed in one scroll (Mike 9/1); 'chips' = style chips filter the grid
  const money = (c) => '$' + (c / 100).toFixed(2);
  const range = (a, b) => (a === b ? money(a) : money(a) + ' – ' + money(b));

  function init(root) {
    if (root.dataset.cbGripReady) return;
    root.dataset.cbGripReady = '1';
    let D;
    try { D = JSON.parse(root.querySelector('[data-cb-grip-data]').textContent); } catch (e) { return; }
    const byColor = {};
    D.variants.forEach((v) => { (byColor[v.color] = byColor[v.color] || []).push(v); });
    const avail = (c) => byColor[c].filter((v) => v.available);
    const colors = Object.keys(byColor).filter((c) => avail(c).length);
    if (!colors.length) { root.hidden = true; return; }
    const styleOf = (c) => (D.styles && D.styles[c]) || 'Other';
    const styleColors = {};
    colors.forEach((c) => { (styleColors[styleOf(c)] = styleColors[styleOf(c)] || []).push(c); });
    const styles = Object.keys(styleColors).sort((a, b) => {
      let ia = STYLE_ORDER.indexOf(a), ib = STYLE_ORDER.indexOf(b);
      if (ia < 0) ia = 99; if (ib < 0) ib = 99;
      return ia - ib || a.localeCompare(b);
    });
    styles.forEach((s) => styleColors[s].sort((a, b) => a.localeCompare(b)));
    const img = (c, w) => { const u = ((D.images && D.images[c]) || [])[0] || ''; return u ? u + (u.includes('?') ? '&' : '?') + 'width=' + (w || 200) : ''; };
    const FEATURED_ORDER = ['Jet Black', 'Diamond White', 'Crimson Red', 'Navy Blue', 'Polar Blue', 'Neon Pink', 'Lucky Green', 'Neon Yellow', 'Blaze Orange', 'Vegas Gold', 'Violet Purple', 'Platinum Gray'];
    // with-a-bat pricing: solids get data-solid-off cents knocked off (matched by an automatic discount in the cart)
    const solidOff = parseInt(root.dataset.solidOff || '0', 10) || 0;
    const eff = (v) => (solidOff && styleOf(v.color) === 'Solid' ? v.price - solidOff : v.price);
    const colorPrice = (c) => { const p = avail(c).map(eff); return range(Math.min(...p), Math.max(...p)); };
    const allPrices = colors.flatMap((c) => avail(c).map(eff));
    const minPrice = Math.min(...allPrices);

    const $ = (sel) => root.querySelector(sel);
    const el = {
      from: $('[data-cb-grip-from]'), featured: $('[data-cb-grip-featured]'), picked: $('[data-cb-grip-picked]'),
      pickedImg: $('[data-cb-grip-picked-img]'), pickedName: $('[data-cb-grip-picked-name]'), pickedMeta: $('[data-cb-grip-picked-meta]'),
      modal: $('[data-cb-grip-modal]'), mPrice: $('[data-cb-grip-modal-price]'), styles: $('[data-cb-grip-styles]'),
      colors: $('[data-cb-grip-colors]'), colorName: $('[data-cb-grip-colorname]'), thk: $('[data-cb-grip-thk]'), thkHint: $('[data-cb-grip-thk-hint]'), body: $('[data-cb-grip-body]'), confirm: $('[data-cb-grip-confirm]')
    };
    el.from.textContent = range(minPrice, Math.max(...allPrices));   // e.g. "$16.99 – $21.99" (Mike: show the max too)

    const sel = { style: styles[0], color: null, thk: null };   // modal working selection
    let chosen = null;                                          // confirmed {variant, color, thk}

    // ---- featured swatches on the card (first 8 in style order, Solid first) ----
    const pool = styles.flatMap((s) => styleColors[s]);
    const featured = FEATURED_ORDER.filter((c) => pool.includes(c)).concat(pool.filter((c) => !FEATURED_ORDER.includes(c))).slice(0, 8);
    el.featured.innerHTML = '';
    // "See N more colors" — N = in-stock colorways beyond the ones visible on the card
    // (5 on phones where the CSS hides the 6th+, 8 on desktop). Recomputed on resize.
    const moreBtn = root.querySelector('.cb-grip__actions [data-cb-grip-open]');
    const setMoreLabel = () => {
      const shown = Math.min(featured.length, window.matchMedia('(max-width: 600px)').matches ? 5 : 8);
      const more = colors.length - shown;
      if (moreBtn) moreBtn.textContent = more > 0 ? 'See ' + more + ' more colors' : 'See all colors';
    };
    setMoreLabel();
    window.addEventListener('resize', setMoreLabel);
    featured.forEach((c) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'cb-grip__sw';
      b.innerHTML = '<span class="cb-grip__sw-img"><img src="' + img(c) + '" alt="' + c + '" loading="lazy"></span>'
        + '<span class="cb-grip__sw-name">' + c + '</span><span class="cb-grip__sw-price">' + colorPrice(c) + '</span>';
      b.addEventListener('click', () => { sel.style = styleOf(c); sel.color = c; sel.thk = null; open(); });
      el.featured.appendChild(b);
    });

    // ---- modal ----
    function renderStyles() {
      el.styles.innerHTML = '';
      el.styles.hidden = LAYOUT === 'stacked';
      if (LAYOUT === 'stacked') return;
      styles.forEach((s) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'cb-grip-chip' + (s === sel.style ? ' is-active' : '');
        b.innerHTML = s + ' <span class="cb-grip-chip__ct">(' + styleColors[s].length + ')</span>';
        b.addEventListener('click', () => { sel.style = s; sel.color = null; sel.thk = null; renderAll(); });
        el.styles.appendChild(b);
      });
    }
    function colorCard(c) {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'cb-grip-card' + (c === sel.color ? ' is-active' : '');
      b.dataset.color = c;
      b.innerHTML = '<span class="cb-grip-card__img"><img src="' + img(c, 300) + '" alt="' + c + '" loading="lazy"></span>'
        + '<span class="cb-grip-card__name">' + c + '</span><span class="cb-grip-card__price">' + colorPrice(c) + '</span>';
      b.addEventListener('click', () => { sel.color = c; sel.thk = null; markActive(); renderThk(); });
      return b;
    }
    function markActive() {
      el.colors.querySelectorAll('.cb-grip-card').forEach((b) => b.classList.toggle('is-active', b.dataset.color === sel.color));
      el.colorName.textContent = sel.color ? '— ' + sel.color : '';
    }
    function renderColors() {
      el.colors.innerHTML = '';
      const groups = LAYOUT === 'stacked' ? styles : [sel.style];
      groups.forEach((s) => {
        if (LAYOUT === 'stacked') {
          const h = document.createElement('div'); h.className = 'cb-grip-group__h';
          h.innerHTML = s + ' <span class="cb-grip-chip__ct">(' + styleColors[s].length + ')</span>';
          el.colors.appendChild(h);
        }
        const grid = document.createElement('div'); grid.className = 'cb-grip-grid';
        styleColors[s].forEach((c) => grid.appendChild(colorCard(c)));
        el.colors.appendChild(grid);
      });
      markActive();
    }
    function renderThk() {
      el.thk.innerHTML = '';
      const have = sel.color ? avail(sel.color) : [];
      el.thkHint.hidden = !!sel.color;
      el.thk.hidden = !sel.color;
      if (sel.color) {
        // only thicknesses actually in stock for this colorway — no greyed/struck chips
        THK_ORDER.filter((t) => have.some((x) => x.thk === t)).forEach((t) => {
          const b = document.createElement('button');
          b.type = 'button'; b.className = 'cb-grip-chip' + (t === sel.thk ? ' is-active' : '');
          b.textContent = t.replace('mm', ' mm');
          b.addEventListener('click', () => { sel.thk = t; renderThk(); });
          el.thk.appendChild(b);
        });
        const missing = THK_ORDER.filter((t) => !have.some((x) => x.thk === t));
        if (missing.length) {
          const n = document.createElement('span'); n.className = 'cb-grip-thk__note';
          n.textContent = (missing.length === 1 ? missing[0].replace('mm', ' mm') + ' is' : missing.map((t) => t.replace('mm', ' mm')).join(' and ') + ' are') + ' sold out in ' + sel.color;
          el.thk.appendChild(n);
        }
      }
      // auto-pick the only thickness in stock
      if (sel.color && !sel.thk && have.length === 1) { sel.thk = have[0].thk; renderThk(); return; }
      const v = current();
      el.confirm.disabled = !v;
      el.confirm.textContent = v ? 'Add this grip · ' + money(eff(v)) : (sel.color ? 'Select a thickness' : 'Select a colorway and thickness');
      el.mPrice.textContent = v ? money(eff(v)) : (sel.color ? colorPrice(sel.color) : range(minPrice, Math.max(...allPrices)));
    }
    function current() { return sel.color && sel.thk ? avail(sel.color).find((v) => v.thk === sel.thk) : null; }
    function renderAll() { renderStyles(); renderColors(); renderThk(); }
    function open() {
      if (chosen && !sel.color) { sel.style = styleOf(chosen.color); sel.color = chosen.color; sel.thk = chosen.thk; }
      renderAll();
      if (typeof el.modal.showModal === 'function') el.modal.showModal(); else el.modal.setAttribute('open', '');
      const active = el.colors.querySelector('.cb-grip-card.is-active');
      if (active) setTimeout(() => active.scrollIntoView({ block: 'center' }), 30); else el.body.scrollTop = 0;
      document.documentElement.classList.add('cb-grip-modal-open');
    }
    function close() {
      if (el.modal.open) el.modal.close(); else el.modal.removeAttribute('open');
      document.documentElement.classList.remove('cb-grip-modal-open');
    }
    root.querySelectorAll('[data-cb-grip-open]').forEach((b) => b.addEventListener('click', () => { if (!chosen) { sel.color = null; sel.thk = null; } open(); }));
    root.querySelectorAll('[data-cb-grip-close]').forEach((b) => b.addEventListener('click', close));
    // "Why a Lizard Skins grip?" article
    const why = root.querySelector('[data-cb-grip-why]');
    if (why) {
      const openWhy = () => { if (typeof why.showModal === 'function') why.showModal(); else why.setAttribute('open', ''); why.querySelector('.cb-grip-modal__body').scrollTop = 0; document.documentElement.classList.add('cb-grip-modal-open'); };
      const closeWhy = () => { if (why.open) why.close(); else why.removeAttribute('open'); document.documentElement.classList.remove('cb-grip-modal-open'); };
      root.querySelectorAll('[data-cb-grip-why-open]').forEach((b) => b.addEventListener('click', openWhy));
      root.querySelectorAll('[data-cb-grip-why-close]').forEach((b) => b.addEventListener('click', closeWhy));
      why.addEventListener('click', (e) => { if (e.target === why) closeWhy(); });
      why.addEventListener('close', () => document.documentElement.classList.remove('cb-grip-modal-open'));
    }
    el.modal.addEventListener('click', (e) => { if (e.target === el.modal) close(); });
    el.modal.addEventListener('close', () => document.documentElement.classList.remove('cb-grip-modal-open'));
    el.confirm.addEventListener('click', () => {
      const v = current(); if (!v) return;
      chosen = { variant: v, color: sel.color, thk: sel.thk };
      el.pickedImg.src = img(sel.color);
      el.pickedName.textContent = 'Lizard Skins DSP Ultra — ' + sel.color;
      el.pickedMeta.textContent = sel.thk.replace('mm', ' mm') + ' · ' + money(eff(v)) + ' · added with your bat';
      el.picked.hidden = false; el.featured.hidden = true; root.querySelector('.cb-grip__actions').hidden = true;
      root.classList.add('is-chosen');
      close();
    });
    root.querySelector('[data-cb-grip-remove]').addEventListener('click', () => {
      chosen = null; sel.color = null; sel.thk = null;
      el.picked.hidden = true; el.featured.hidden = false; root.querySelector('.cb-grip__actions').hidden = false;
      root.classList.remove('is-chosen');
    });

    // ---- hook the bat's Add to Cart: add the grip first, then let the theme add the bat ----
    const section = root.closest('.shopify-section') || document;
    section.addEventListener('submit', async (evt) => {
      const form = evt.target;
      if (!form.matches('.js-product-form-main')) return;
      if (!chosen || form.dataset.cbGripDone === '1') { delete form.dataset.cbGripDone; return; }
      evt.preventDefault(); evt.stopImmediatePropagation();
      const btn = form.querySelector('[name="add"]');
      if (btn) btn.classList.add('is-loading');
      try {
        const r = await fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: chosen.variant.id, quantity: 1, properties: { 'For bat': root.dataset.batTitle } }] })
        });
        if (!r.ok) throw new Error('grip add failed ' + r.status);
      } catch (e) {
        console.warn('[cb-grip]', e);   // grip failed — still add the bat, just note it
      }
      form.dataset.cbGripDone = '1';
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
    }, true);   // capture: runs before the theme's product-form submit handler
  }

  const boot = () => document.querySelectorAll('[data-cb-grip]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // the theme replaces product-info blocks on variant change; re-init if ours gets re-rendered
  document.addEventListener('on:variant:change', () => setTimeout(boot, 50));
})();
